export default {
    getAllJobsStatus(state) {
        return state.allJobsStatusList;
    },
};